const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const fetchMovimientosVertical = async (filters = {}) => {
  try {
    const response = await fetch(`${API_URL}/movimientos-lenceria-vertical/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    });

    if (!response.ok) {
      throw new Error('Error al obtener movimientos verticales');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchMovimientosVertical:', error);
    throw error;
  }
};

export const fetchMovimientosVerticalByEdificio = async (edificioId, limit = 50) => {
  try {
    const response = await fetch(`${API_URL}/movimientos-lenceria-vertical/edificio/${edificioId}?limit=${limit}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al obtener movimientos del edificio');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchMovimientosVerticalByEdificio:', error);
    throw error;
  }
};

export const createMovimientoVertical = async (data) => {
  try {
    const response = await fetch(`${API_URL}/movimientos-lenceria-vertical/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('Error al crear movimiento vertical');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en createMovimientoVertical:', error);
    throw error;
  }
};

export const fetchReporteMovimientosVertical = async (edificioId, fechaInicio, fechaFin) => {
  try {
    const response = await fetch(`${API_URL}/movimientos-lenceria-vertical/reporte`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ edificioId, fechaInicio, fechaFin }),
    });

    if (!response.ok) {
      throw new Error('Error al generar reporte');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchReporteMovimientosVertical:', error);
    throw error;
  }
};
